@switch (question?.questionSubType) { @case (questionSubType.NPS) {
@switch(question?.questionSpecificOptions?.npsRepresentation) { @case (npsRepresentation.BOXES) {
@switch(question?.questionSpecificOptions?.npsColor) { @case (npsColor.GRADIENT) {
<div class="nps-container-boxes-gradient" [class.mobile-view]="viewMode === 'mobile'">
  <div class="nps-labels" [style.width]="viewMode === 'mobile' ? toNumber(11) * 25.5 + 'px' : toNumber(11) * 47 + 'px'">
    @for (label of question?.questionSpecificOptions?.labels; track label) {
    <span class="text-secondary-500 text-xs text-capitalize">{{ label?.text }}</span>
    }
  </div>

  <div class="nps-scale-boxes-gradient">
    @for (score of npsScale; track score) {
    <div class="nps-box-gradient" [attr.data-score]="score" [class]="getScoreClass(score)"
      (click)="onScoreSelect(score); $event.stopPropagation()">
      <span class="score-number">{{ score }}</span>
    </div>
    }
  </div>
</div>
} @case (npsColor.TRICOLOR) {
<div class="nps-container-boxes-tricolor" [class.mobile-view]="viewMode === 'mobile'">
  <div class="nps-labels" [style.width]="viewMode === 'mobile' ? toNumber(11) * 25.5 + 'px' : toNumber(11) * 47 + 'px'">
    @for (label of question?.questionSpecificOptions?.labels; track label) {
    <span class="text-secondary-500 text-xs text-capitalize">{{ label?.text }}</span>
    }
  </div>
  <div class="nps-scale-boxes-tricolor">
    @for (score of npsScale; track score) {
    <div class="nps-box-tricolor" [attr.data-score]="score" [class]="getScoreClass(score)"
      [class.less-than-selected]="isLessThanSelected(score)" [class.less-than-hovered]="isLessThanHovered(score)"
      (click)="onScoreSelect(score); $event.stopPropagation()" (mouseenter)="onScoreHover(score)"
      (mouseleave)="onScoreHover(null)">
      <span class="score-number">{{ score }}</span>
    </div>
    }
  </div>
</div>
} @default {
<div class="nps-container-boxes-default" [class.mobile-view]="viewMode === 'mobile'">
  <div class="nps-labels" [style.width]="viewMode === 'mobile' ? toNumber(11) * 25.5 + 'px' : toNumber(11) * 47 + 'px'">
    @for (label of question?.questionSpecificOptions?.labels; track label) {
    <span class="text-secondary-500 text-xs text-capitalize">{{ label?.text }}</span>
    }
  </div>
  <div class="nps-scale-boxes-default">
    @for (score of npsScale; track score) {
    <div class="nps-box-default" [class]="getScoreClass(score)"
      (click)="onScoreSelect(score); $event.stopPropagation()">
      <span class="score-number">{{ score }}</span>
    </div>
    }
  </div>
</div>
} } } @case (npsRepresentation.CIRCLES) { @switch(question?.questionSpecificOptions?.npsColor) {
@case (npsColor.GRADIENT) {
<div class="nps-container-circles-gradient" [class.mobile-view]="viewMode === 'mobile'">
  <div class="nps-labels" [style.width]="viewMode === 'mobile' ? toNumber(11) * 25.5 + 'px' : toNumber(11) * 47 + 'px'">
    @for (label of question?.questionSpecificOptions?.labels; track label) {
    <span class="text-secondary-500 text-xs text-capitalize">{{ label?.text }}</span>
    }
  </div>
  <div class="nps-scale-circles-gradient">
    @for (score of npsScale; track score) {
    <div class="nps-circle-gradient" [attr.data-score]="score" [class]="getScoreClass(score)"
      (click)="onScoreSelect(score); $event.stopPropagation()">
      <span class="score-number">{{ score }}</span>
    </div>
    }
  </div>
</div>
} @case (npsColor.TRICOLOR) {
<div class="nps-container-circles-tricolor" [class.mobile-view]="viewMode === 'mobile'">
  <div class="nps-labels" [style.width]="viewMode === 'mobile' ? toNumber(11) * 25.5 + 'px' : toNumber(11) * 47 + 'px'">
    @for (label of question?.questionSpecificOptions?.labels; track label) {
    <span class="text-secondary-500 text-xs text-capitalize">{{ label?.text }}</span>
    }
  </div>
  <div class="nps-scale-circles-tricolor">
    @for (score of npsScale; track score) {
    <div class="nps-circle-tricolor" [attr.data-score]="score" [class]="getScoreClass(score)"
      [class.less-than-selected]="isLessThanSelected(score)" [class.less-than-hovered]="isLessThanHovered(score)"
      (click)="onScoreSelect(score); $event.stopPropagation()" (mouseenter)="onScoreHover(score)"
      (mouseleave)="onScoreHover(null)">
      <span class="score-number">{{ score }}</span>
    </div>
    }
  </div>
</div>
} @default {
<div class="nps-container-circles-default" [class.mobile-view]="viewMode === 'mobile'">
  <div class="nps-labels" [style.width]="viewMode === 'mobile' ? toNumber(11) * 25.5 + 'px' : toNumber(11) * 47 + 'px'">
    @for (label of question?.questionSpecificOptions?.labels; track label) {
    <span class="text-secondary-500 text-xs text-capitalize">{{ label?.text }}</span>
    }
  </div>
  <div class="nps-scale-circles-default">
    @for (score of npsScale; track score) {
    <div class="nps-circle-default" [class]="getScoreClass(score)"
      (click)="onScoreSelect(score); $event.stopPropagation()">
      <span class="score-number">{{ score }}</span>
    </div>
    }
  </div>
</div>
} } } @case (npsRepresentation.RECTANGLES) { @switch(question?.questionSpecificOptions?.npsColor) {
@case (npsColor.GRADIENT) {
<div class="nps-container-rectangles-gradient" [class.mobile-view]="viewMode === 'mobile'">
  <div class="nps-labels" [style.width]="viewMode === 'mobile' ? toNumber(11) * 25.5 + 'px' : toNumber(11) * 47 + 'px'">
    @for (label of question?.questionSpecificOptions?.labels; track label) {
    <span class="text-secondary-500 text-xs text-capitalize">{{ label?.text }}</span>
    }
  </div>
  <div class="nps-scale-rectangles-gradient">
    @for (score of npsScale; track score) {
    <div class="nps-rectangle-gradient" [attr.data-score]="score" [class]="getScoreClass(score)"
      (click)="onScoreSelect(score); $event.stopPropagation()">
      <span class="score-number">{{ score }}</span>
    </div>
    }
  </div>
</div>
} @case (npsColor.TRICOLOR) {
<div class="nps-container-rectangles-tricolor" [class.mobile-view]="viewMode === 'mobile'">
  <div class="nps-labels" [style.width]="viewMode === 'mobile' ? toNumber(11) * 25.5 + 'px' : toNumber(11) * 47 + 'px'">
    @for (label of question?.questionSpecificOptions?.labels; track label) {
    <span class="text-secondary-500 text-xs text-capitalize">{{ label?.text }}</span>
    }
  </div>
  <div class="nps-scale-rectangles-tricolor">
    @for (score of npsScale; track score) {
    <div class="nps-rectangle-tricolor" [attr.data-score]="score" [class]="getScoreClass(score)"
      [class.less-than-selected]="isLessThanSelected(score)" [class.less-than-hovered]="isLessThanHovered(score)"
      (click)="onScoreSelect(score); $event.stopPropagation()" (mouseenter)="onScoreHover(score)"
      (mouseleave)="onScoreHover(null)">
      <span class="score-number">{{ score }}</span>
    </div>
    }
  </div>
</div>
} @default {
<div class="nps-container-rectangles-default" [class.mobile-view]="viewMode === 'mobile'">
  <div class="nps-labels" [style.width]="viewMode === 'mobile' ? toNumber(11) * 25.5 + 'px' : toNumber(11) * 47 + 'px'">
    @for (label of question?.questionSpecificOptions?.labels; track label) {
    <span class="text-secondary-500 text-xs text-capitalize">{{ label?.text }}</span>
    }
  </div>
  <div class="nps-scale-rectangles-default">
    @for (score of npsScale; track score) {
    <div class="nps-rectangle-default" [class]="getScoreClass(score)"
      (click)="onScoreSelect(score); $event.stopPropagation()">
      <span class="score-number">{{ score }}</span>
    </div>
    }
  </div>
</div>
} } } } } }

<!-- Follow-up Question Section -->
@if(currentFollowUpQuestions && currentFollowUpQuestions.length > 0 && selectedScore !== null) {
@for (followUpQuestion of currentFollowUpQuestions; track followUpQuestion.followUpQuestionId ||
followUpQuestion.questionId || $index; let i = $index) { @let questionId =
followUpQuestion.followUpQuestionId || followUpQuestion.questionId; @let questionText =
followUpQuestion.followUpQuestion || followUpQuestion.question;
<div class="follow-up-question-container">
  <h5 class="question-title">
    <span class="follow-up-question-order" [class.mobile-view]="viewMode === 'mobile'"
      [style.color]=" page === 'theme' ? data?.titleColor : ''"
      [style.font-size]=" page === 'theme' ? data?.titleFontSize : ''"
      [style.font-family]=" page === 'theme' ? data?.titleFontFamily : ''"
      [style.font-weight]=" page === 'theme' ? data?.titleFontWeight : ''">F{{ i + 1 }}. </span>
    <span class="follow-up-question-text" [class.mobile-view]="viewMode === 'mobile'"
      [style.color]=" page === 'theme' ? data?.titleColor : ''"
      [style.font-size]=" page === 'theme' ? data?.titleFontSize : ''"
      [style.font-family]=" page === 'theme' ? data?.titleFontFamily : ''"
      [style.font-weight]=" page === 'theme' ? data?.titleFontWeight : ''">{{ questionText }}</span>
  </h5>

  @if(followUpQuestion.followUpQuestionType === questionType.CHOICE_BASED ) {
  @if((followUpQuestion.followUpQuestionOptions && followUpQuestion.followUpQuestionOptions.length >
  0) || (followUpQuestion.questionOptions && followUpQuestion.questionOptions.length > 0)) {
  <div class="follow-up-options">
    @for (option of getFollowUpDisplayOptions(followUpQuestion); track option.optionId ||
    option.text || $index) {
    <div class="form-check">
      <input class="form-check-input" type="checkbox" [name]="'followUp_' + questionId + '_' + $index"
        (click)="$event.stopPropagation()"
        [id]="'option_' + questionId + '_' + (option.optionId || $index) + '_' + $index"
        [checked]="isOptionSelected(questionId, option.optionId || option.text)" (change)="
          onFollowUpOptionSelect(questionId, option.optionId || option.text, true);
          $event.stopPropagation()
        " />
      <label class="form-check-label" [for]="'option_' + questionId + '_' + (option.optionId || $index) + '_' + $index"
        [style.color]=" page === 'theme' ? data?.descriptionColor : ''"
        [style.font-size]=" page === 'theme' ? data?.descriptionFontSize : ''"
        [style.font-family]=" page === 'theme' ? data?.descriptionFontFamily : ''"
        [style.font-weight]=" page === 'theme' ? data?.descriptionFontWeight : ''">
        {{ option.text }}
      </label>
    </div>
    }
    @if (getFollowUpOthersOption(followUpQuestion); as othersOption) {
    <div class="form-check mb-2">
      <input class="form-check-input" type="checkbox" [name]="'followUp_' + questionId + '_others'"
        (click)="$event.stopPropagation()" [id]="'option_' + questionId + '_others'"
        [checked]="isFollowUpOthersSelected(questionId, followUpQuestion)" (change)="
          onFollowUpOptionSelect(questionId, othersOption.optionId || othersOption.text, true);
          $event.stopPropagation()
        " />
      <label class="form-check-label" [for]="'option_' + questionId + '_others'"
        [style.color]=" page === 'theme' ? data?.descriptionColor : ''"
        [style.font-size]=" page === 'theme' ? data?.descriptionFontSize : ''"
        [style.font-family]=" page === 'theme' ? data?.descriptionFontFamily : ''"
        [style.font-weight]=" page === 'theme' ? data?.descriptionFontWeight : ''">
        {{ othersOption.text }}
      </label>
    </div>
    @if (isFollowUpOthersSelected(questionId, followUpQuestion)) {
    <div class="follow-up-others-input-container mt-4 question-content-width">
      <input type="text" class="form-control follow-up-others-input" [ngModel]="getFollowUpOthersText(questionId)"
        (ngModelChange)="onFollowUpOthersTextChange(questionId, $event)" (click)="$event.stopPropagation()"
        placeholder="Please specify" />
    </div>
    }
    }
  </div>
  } } @else if(followUpQuestion.followUpQuestionType === questionType.TEXT_INPUT ) {
  <div class="follow-up-text-input question-content-width">
    <app-textarea [rows]="3" [formControl]="getFollowUpResponseControl(questionId)" (input)="
        onFollowUpTextChange(questionId, $any($event.target).value); $event.stopPropagation()
      " placeholder="Enter your response..." (click)="$event.stopPropagation()"></app-textarea>
  </div>
  }
</div>
} }
<!-- End of Follow-up Question Section -->